import { render, staticRenderFns } from "./TheSlidesCreate.vue?vue&type=template&id=47d43d28&"
import script from "./TheSlidesCreate.vue?vue&type=script&lang=js&"
export * from "./TheSlidesCreate.vue?vue&type=script&lang=js&"
import style0 from "./TheSlidesCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports